const BASE = process.env.REACT_APP_BACKEND_URL;

export async function api(path, opts = {}) {
  const headers = {};
  let body;
  if (opts.body !== undefined) {
    if (opts.isForm) body = opts.body;
    else { headers["Content-Type"] = "application/json"; body = JSON.stringify(opts.body); }
  }
  const res = await fetch(`${BASE}/api${path}`, {
    method: opts.method || "GET",
    headers,
    body,
    credentials: "include",
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { detail = (await res.json()).detail || detail; } catch {}
    const e = new Error(detail); e.status = res.status; throw e;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

export const palette = {
  emerald: "#651F33", blue: "#3B82F6", orange: "#F97316", yellow: "#FCD34D",
  red: "#F43F5E", violet: "#A78BFA", cyan: "#22D3EE", water: "#22D3EE",
};

export const moodColor = {
  Happy: palette.emerald, Proud: palette.yellow, Cheering: palette.orange,
  Hungry: palette.red, Sleepy: palette.violet,
};
